/*
 This is a manifest file that'll be compiled into application.js, which will include all the files listed below.

 Any JavaScript/Coffee file within this directory, lib/assets/javascripts, vendor/assets/javascripts,
 or any plugin's vendor/assets/javascripts directory can be referenced here using a relative path.

 It's not advisable to add code directly here, but if you do, it'll appear at the bottom of the
 compiled file.

 Read Sprockets README (https://github.com/sstephenson/sprockets#sprockets-directives) for details about supported directives.
 */

import $ from 'jquery';
import ReactDOM from 'react-dom';
import TeamTrends from 'legacy/javascripts/components/team_trends.es6';
import AgentTrends from 'legacy/javascripts/components/agent_trends.es6';
import ServiceRecoveryDashboard from 'legacy/javascripts/components/service_recovery_dashboard.es6';
import loadingImage from 'legacy/images/loading-grey.gif';
import errorImage from 'legacy/images/error.png';

import Rails from '@rails/ujs';
import dataConfirmModal from 'legacy/libs/data-confirm-modal';

import jQueryUjs from 'jquery-ujs';

/* eslint-disable */
require('legacy/libs/bootstrap/collapse');
require('legacy/libs/bootstrap/modal');
require('legacy/libs/bootstrap/tab');
require('legacy/libs/bootstrap/tooltip');
require('legacy/libs/bootstrap-daterangepicker/daterangepicker');
require('legacy/libs/bootstrap-switch');
require('eonasdan-bootstrap-datetimepicker');
require('jquery-ui/ui/widgets/autocomplete');
require('jquery-ui/themes/base/slider.css');
require('jquery-ui/ui/widgets/slider');

// Some of these legacy libs are required across all application
// This is why these three libraries are initialized here and in commons.jsx
// And to avoid double initialization we need some flag
// TODO: regroup common libs
if (!window.__legacyLibsInited) {
  require('legacy/libs/bootstrap/dropdown'); // dropdown fixed on line 80 to not interfer with custom-ui
  require('legacy/javascripts/custom-ui');
  require('legacy/libs/bootstrap-switch');
}

window.__legacyLibsInited = true;

require('legacy/libs/bootstrap-daterangepicker/daterangepicker.css');
/* eslint-enable */

dataConfirmModal(Rails);

window.$ = $;

// DataTables too
/* eslint-disable */
require('jszip');
require('pdfmake');
require('datatables.net-bs');
require('datatables.net-buttons-bs');
require('datatables.net-buttons/js/buttons.colVis.js')();
require('datatables.net-buttons/js/buttons.html5.js')();
require('datatables.net-buttons/js/buttons.print.js')();
/* eslint-enable */

require('legacy/javascripts/accounts');
require('legacy/javascripts/activity_log');
require('legacy/javascripts/additional_question');
require('legacy/javascripts/ajax_grouptree');
require('legacy/javascripts/ajax_teamtree');
require('legacy/javascripts/alert_filter_settings');
require('legacy/javascripts/alerts');
require('legacy/javascripts/api');
require('legacy/javascripts/bootstrap-datepickers');
require('legacy/javascripts/branding_preview');
require('legacy/javascripts/brandings');
require('legacy/javascripts/bulk_invitations');
require('legacy/javascripts/bulk_updates');
require('legacy/javascripts/check_alert_filters');
require('legacy/javascripts/cloudinary');
require('legacy/javascripts/companies');
require('legacy/javascripts/dashboards');
require('legacy/javascripts/date_range_query_string');
require('legacy/javascripts/deactivation');
require('legacy/javascripts/edit_feedback');
require('legacy/javascripts/employee_channel');
require('legacy/javascripts/employees');
require('legacy/javascripts/exports');
require('legacy/javascripts/fa_4_compatibility');
require('legacy/javascripts/feedback_preview');
require('legacy/javascripts/filter_question');
require('legacy/javascripts/five_star_selection');
require('legacy/javascripts/gear');
require('legacy/javascripts/groups_tree');
require('legacy/javascripts/helpers');
require('legacy/javascripts/helpertext');
require('legacy/javascripts/js_timezone');
require('legacy/javascripts/library');
require('legacy/javascripts/login');
require('legacy/javascripts/mailcheck_stella');
require('legacy/javascripts/manual_request_form');
require('legacy/javascripts/notification');
require('legacy/javascripts/notification_settings');
require('legacy/javascripts/preview');
require('legacy/javascripts/primary_color');
require('legacy/javascripts/reporting_groups');
require('legacy/javascripts/request_status');
require('legacy/javascripts/reward_toggle');
require('legacy/javascripts/rewards_report');
require('legacy/javascripts/rewards_votes');
require('legacy/javascripts/select_employee_for_request');
require('legacy/javascripts/settings');
require('legacy/javascripts/slider');
require('legacy/javascripts/solicitations');
require('legacy/javascripts/spam_tests');
require('legacy/javascripts/stream');
require('legacy/javascripts/teamtree');
require('legacy/javascripts/text');
require('legacy/javascripts/translations');
require('legacy/javascripts/unsubcriptions');
require('legacy/javascripts/welcome_cadmin');

require('legacy/stylesheets/application.scss');

document.addEventListener('DOMContentLoaded', () => {
  Rails.start();
  jQueryUjs($);

  const teamTrendsMountRoot = document.querySelector(
    '.js-team-trends-mount-root'
  );

  if (teamTrendsMountRoot) {
    ReactDOM.render(
      <TeamTrends loading_image={loadingImage} error_image={errorImage} />,
      teamTrendsMountRoot
    );
  }

  const agentTrendsMountRoot = document.querySelector(
    '.js-agent-trends-mount-root'
  );

  if (agentTrendsMountRoot) {
    ReactDOM.render(
      <AgentTrends loading_image={loadingImage} error_image={errorImage} />,
      agentTrendsMountRoot
    );
  }

  const serviceRecoveryMountRoot = document.querySelector(
    '.js-service-recovery-mount-root'
  );

  if (serviceRecoveryMountRoot) {
    ReactDOM.render(
      <ServiceRecoveryDashboard
        loading_image={loadingImage}
        error_image={errorImage}
      />,
      serviceRecoveryMountRoot
    );
  }
});
